import FadeAnimation from 'src/components/animation/FadeAnimation';
import MainThumbnail from 'src/components/gallery/MainThumbnail';
import Guestbook from 'src/components/guestBook/GuestBook';
import DateSection from 'src/components/info/DateSection';
import GallerySection from 'src/components/info/GallerySection';
import HeartSection from 'src/components/info/HeartSection';
import LetterSection from 'src/components/info/LetterSection';
import MapSection from 'src/components/info/MapSection';
import InfoFooter from 'src/components/layouts/InfoFooter';

const InfoPage = () => {
  return (
    <>
      <h1 className="a11y-hidden">청첩장</h1>
      <MainThumbnail />
      <FadeAnimation>
        <LetterSection />
      </FadeAnimation>
      <FadeAnimation>
        <DateSection />
      </FadeAnimation>
      <FadeAnimation>
        <GallerySection />
      </FadeAnimation>
      <FadeAnimation>
        <Guestbook />
      </FadeAnimation>
      <FadeAnimation>
        <MapSection />
      </FadeAnimation>
      <HeartSection />
      <InfoFooter />
    </>
  );
};

export default InfoPage;
